import { render, staticRenderFns } from "./importcsv.vue?vue&type=template&id=564b30e1&scoped=true"
import script from "./importcsv.vue?vue&type=script&lang=js"
export * from "./importcsv.vue?vue&type=script&lang=js"
import style0 from "./importcsv.vue?vue&type=style&index=0&id=564b30e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564b30e1",
  null
  
)

export default component.exports